import templateUrl from './eproViewer.html';
import controller from './eproViewer.controller';
import './eproViewer.scss';

const eproViewerComponent = {
	bindings: {
		title: '@'
	},
	templateUrl,
	controller
};

export default eproViewerComponent;
